//@ts-nocheck
import { Group } from "@visx/group";
import { ICourseNodeCluster } from "../datastructures/dataviz";
import { Circle } from "@visx/shape";
import "../styles/coursenode.css";
import { Text } from "@visx/text";
import { GetAreaFullName } from "../utils/stringSet";

//Vis inspiration: https://github.com/vasturiano/force-graph

export const CourseNodeCluster = ({
  position,
  area,
  expanded,
  hasFocus,
  coreAngleArray,
}: ICourseNodeCluster) => {
  const expandedRadius = 400;
  const exitBtnRadiusFactor = 1.2;
  const radiiArray = [400, 240, 60];
  const radiiLabels = {
    400: "indirectly related courses",
    240: "directly related courses",
    // 80: "focused course"
  };
  const radiiTooltips = {
    400: "These courses are not related by a single prerequisite or other relationship.",
    240: "These courses are related by a single prerequisite or other relationship.",
    // 80: "Current"
  };

  return (
    <Group>
      <Circle
        className={
          "area-" +
          area +
          (!expanded ? " dashed-outline-flow " : "") +
          " circle-animated unexpanded-cluster"
        }
        cx={position.x}
        cy={position.y}
        r={expanded ? expandedRadius : expandedRadius / 4}
        fillOpacity={expanded ? "0" : "1"}
        stroke="black"
        strokeWidth={expanded ? "0" : "5"}
        strokeOpacity={expanded ? "0" : "0.5"}
        strokeDasharray="10"
        strokeDashoffset="2"
        filter={
          expanded ? "none" : "drop-shadow(15px 15px 0px rgb(0 0 0 / 0.2))"
        }
      />
      {/* <Text x={position.x} y={position.y - 32 - (expanded ? expandedRadius : expandedRadius / 4)} textAnchor="middle" fontFamily="Rubik" fontSize="50" className='cluster-title'>
      {GetAreaName(area).toUpperCase()}
    </Text> */}

      {/* Broken Area Name */}
      {expanded ? (
        <>
          <TextCirclePath
            x={position.x}
            y={position.y}
            r={expandedRadius}
            text={GetAreaFullName(area)[0].toUpperCase()}
            dx={0.25}
            dy={-90}
            fontsize={30}
            tooltip={"This is the course area."}
          />
          <TextCirclePath
            x={position.x}
            y={position.y}
            r={expandedRadius}
            text={GetAreaFullName(area)[1].toUpperCase()}
            dx={0.25}
            dy={-30}
            fontsize={30}
            tooltip={"This is the course area."}
          />
        </>
      ) : (
        <>
          <Text
            x={position.x}
            y={position.y - 32 - expandedRadius / 4}
            textAnchor="middle"
            fontFamily="Rubik"
            fontSize="40"
            className="cluster-title"
          >
            {GetAreaFullName(area)[1].toUpperCase()}
          </Text>
          <Text
            x={position.x}
            y={position.y - 86 - expandedRadius / 4}
            textAnchor="middle"
            fontFamily="Rubik"
            fontSize="40"
            className="cluster-title"
          >
            {GetAreaFullName(area)[0].toUpperCase()}
          </Text>
          {/* Number */}
          {area > 0 && area < 7 ? (
            <Text
              x={position.x}
              y={position.y}
              textAnchor="middle"
              verticalAnchor="middle"
              fontFamily="Rubik"
              fontSize="80"
              className="cluster-title"
            >
              {area}
            </Text>
          ) : null}
        </>
      )}
      {/* Core Band Section */}
      {area !== 0 || !expanded ? null : (
        <>
          <defs>
            <mask id={"hole"}>
              <rect x={-500} y={-500} width="1000" height="1000" fill="white" />
              <circle r="240" cx={0} cy={0} fill="black" />
            </mask>
          </defs>
          {/* Text Indicators */}

          {/* Arc 2F */}
          <path
            d={createSvgArc(
              position.x,
              position.y,
              400,
              coreAngleArray[1],
              coreAngleArray[2]
            )}
            mask="url(#hole)"
            fill="#666"
            fillOpacity={0.6}
          ></path>
          {/* Arc 2S */}
          <path
            d={createSvgArc(
              position.x,
              position.y,
              400,
              coreAngleArray[0],
              coreAngleArray[1]
            )}
            mask="url(#hole)"
            fill="#111"
            fillOpacity={0.6}
          ></path>
          {/* Arc 1F  -- > not shown */}
          <path
            d={createSvgArc(
              position.x,
              position.y,
              400,
              coreAngleArray[3],
              coreAngleArray[0]
            )}
            mask="url(#hole)"
            fill="#000"
            fillOpacity={0.0}
          ></path>
          {/* Arc 1S */}
          <path
            d={createSvgArc(
              position.x,
              position.y,
              400,
              coreAngleArray[2],
              coreAngleArray[3]
            )}
            mask="url(#hole)"
            fill="#BBB"
            fillOpacity={0.6}
          ></path>
        </>
      )}
      {expanded
        ? radiiArray.map((el) => {
            return (
              <>
                <Circle
                  key={`c${area}_frag_${el}`}
                  cx={position.x}
                  cy={position.y}
                  r={el}
                  // fill={""}
                  strokeOpacity={expanded ? "0.5" : "0.5"}
                  strokeWidth={el === 60 ? 2 : 1}
                  stroke="black"
                  strokeDasharray="0"
                  strokeDashoffset="2"
                  className={
                    "ClusterInnerCircle dashed-outline-flow area-" + area
                  }
                  // onMouseEnter={() => setShowAnnotations(true)}
                  // onMouseExit={() => setShowAnnotations(false)}
                ></Circle>
                <TextCirclePath
                  key={`c${area}_fragtxt_${el}`}
                  fontsize={20}
                  x={position.x}
                  y={position.y}
                  r={el}
                  dx={0.25}
                  dy={20}
                  text={radiiLabels[el]}
                  tooltip={radiiTooltips[el]}
                ></TextCirclePath>
              </>
            );
          })
        : null}

      {/* Inner prompt text */}
      {/* Instead of redundant "area-X" label - also size issues - use prompt */}
      {expanded && !hasFocus ? (
        <>
          <Text
            x={position.x}
            y={position.y - 12}
            textAnchor="middle"
            fontFamily="Rubik"
            fontSize="20"
            className="cluster-title"
          >
            Select
          </Text>
          <Text
            x={position.x}
            y={position.y + 8}
            textAnchor="middle"
            fontFamily="Rubik"
            fontSize="20"
            className="cluster-title"
          >
            a
          </Text>
          <Text
            x={position.x}
            y={position.y + 28}
            textAnchor="middle"
            fontFamily="Rubik"
            fontSize="20"
            className="cluster-title"
          >
            Course!
          </Text>
        </>
      ) : null}

      {/* close button */}
      {expanded ? (
        <g className="cluster_exit">
          <circle
            cx={position.x}
            cy={
              position.y + 42 + (expanded ? expandedRadius : expandedRadius / 4)
            }
            r={20 * exitBtnRadiusFactor}
            fill={"#EA2027"}
          ></circle>
          <line
            x1={position.x - 8 * exitBtnRadiusFactor}
            y1={
              position.y +
              42 +
              (expanded ? expandedRadius : expandedRadius / 4) -
              8 * exitBtnRadiusFactor
            }
            x2={position.x + 8 * exitBtnRadiusFactor}
            y2={
              position.y +
              42 +
              (expanded ? expandedRadius : expandedRadius / 4) +
              8 * exitBtnRadiusFactor
            }
            strokeWidth={6 * exitBtnRadiusFactor}
            stroke="white"
          ></line>
          <line
            x1={position.x - 8 * exitBtnRadiusFactor}
            y1={
              position.y +
              42 +
              (expanded ? expandedRadius : expandedRadius / 4) +
              8 * exitBtnRadiusFactor
            }
            x2={position.x + 8 * exitBtnRadiusFactor}
            y2={
              position.y +
              42 +
              (expanded ? expandedRadius : expandedRadius / 4) -
              8 * exitBtnRadiusFactor
            }
            strokeWidth={6 * exitBtnRadiusFactor}
            stroke="white"
          ></line>
        </g>
      ) : null}
      {expanded && area === 0 && (
        <>
          <TextCirclePath
            key={"y1f_arctext"}
            fontsize={20}
            x={position.x}
            y={position.y}
            r={400}
            dx={0.375}
            dy={-20}
            text="Year 1 Fall"
            tooltip="Year 1 Fall"
          ></TextCirclePath>
          <TextCirclePathInverted
            key={"y1s_arctext"}
            fontsize={20}
            x={position.x}
            y={position.y}
            r={400}
            dx={0.375}
            dy={25}
            text="Year 1 Spring"
            tooltip="Year 1 Spring"
          ></TextCirclePathInverted>
          <TextCirclePathInverted
            key={"y2f_arctext"}
            fontsize={20}
            x={position.x}
            y={position.y}
            r={400}
            dx={0.125}
            dy={25}
            text="Year 2 Fall"
            tooltip="Year 2 Fall"
          ></TextCirclePathInverted>
          <TextCirclePath
            key={"y2s_arctext"}
            fontsize={20}
            x={position.x}
            y={position.y}
            r={400}
            dx={0.125}
            dy={-20}
            text="Year 2 Spring"
            tooltip="Year 2 Spring"
          ></TextCirclePath>
        </>
      )}
    </Group>
  );
};

interface CirclePathProps {
  x: number;
  y: number;
  r: number;
  dx: number; //normalized angle!
  dy: number;
  text: string;
  tooltip: string;
  fontsize: number;
}

export const TextCirclePath = ({
  x,
  y,
  r,
  dx,
  dy,
  text,
  tooltip,
  fontsize,
}: CirclePathProps) => {
  const id = `radialText-x${x}-y${y}-r${r}`;
  return (
    <>
      <path
        d={`
        M ${x} ${y}
        m -${r}, 0
        a ${r},${r} 0 1,1 ${r * 2},0
        a ${r},${r} 0 1,1 -${r * 2},0
        `}
        fillOpacity={0}
        strokeOpacity={0}
        stroke={"black"}
        id={id}
      />

      <text
        dx={dx * r * 2 * Math.PI}
        dy={dy}
        fontSize={fontsize}
        textAnchor="middle"
        fontFamily="Rubik"
      >
        <textPath href={`#${id}`}>{text}</textPath>
        <title>{tooltip}</title>
      </text>
    </>
  );
};

export const TextCirclePathInverted = ({
  x,
  y,
  r,
  dx,
  dy,
  text,
  tooltip,
  fontsize,
}: CirclePathProps) => {
  const id = `invradialText-x${x}-y${y}-r${r}`;
  // return null;
  return (
    <>
      <path
        d={`
        M ${x} ${y}
        m -${r}, 0
        a ${r},${r} 0 1,0 ${r * 2},0
        a ${r},${r} 0 1,0 -${r * 2},0
        `}
        fillOpacity={0}
        strokeOpacity={0}
        stroke={"black"}
        id={id}
      />

      <text
        dx={dx * r * 2 * Math.PI}
        dy={dy}
        fontSize={fontsize}
        textAnchor="middle"
        fontFamily="Rubik"
      >
        <textPath href={`#${id}`}>{text}</textPath>
        <title>{tooltip}</title>
      </text>
    </>
  );
};

// https://codepen.io/olegn/pen/BXZQxQ
function createSvgArc(x, y, r, startAngle, endAngle) {
  startAngle += Math.PI / 2;
  endAngle += Math.PI / 2;
  if (startAngle > endAngle) {
    var s = startAngle;
    startAngle = endAngle;
    endAngle = s;
  }
  if (endAngle - startAngle > Math.PI * 2) {
    endAngle = Math.PI * 1.99999;
  }

  var largeArc = endAngle - startAngle <= Math.PI ? 0 : 1;

  return [
    "M",
    x,
    y,
    "L",
    x + Math.cos(startAngle) * r,
    y - Math.sin(startAngle) * r,
    "A",
    r,
    r,
    0,
    largeArc,
    0,
    x + Math.cos(endAngle) * r,
    y - Math.sin(endAngle) * r,
    "L",
    x,
    y,
  ].join(" ");
}
